import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { Button } from "@com.mgmtp.a12.widgets/widgets-core/lib/button";
import { ButtonGroup } from "@com.mgmtp.a12.widgets/widgets-core/lib/button-group";
import { ActionContentboxProps } from "@com.mgmtp.a12.widgets/widgets-core/lib/contentbox";
import { Icon } from "@com.mgmtp.a12.widgets/widgets-core/lib/icon";
import { DefaultWidgetMap } from "@com.mgmtp.a12.formengine/formengine-core/lib/view";

import { getViewHtmlId } from "../../focusHandling/sagas";

export const CustomActionContentBoxWithCloseButton = (activityId: string) =>
	function ContentBoxCloseButton(props: ActionContentboxProps) {
		const activity = useSelector(ActivitySelectors.activityById(activityId));
		const dispatch = useDispatch();

		if (activity === undefined) {
			return null;
		}

		const onCloseButtonClicked = (): void => {
			dispatch(ActivityActions.cancelRequested({ activityIds: [activity.id] }));
		};

		return (
			<StyledCustomActionContentBox
				{...props}
				id={getViewHtmlId(activityId)}
				headingButtons={
					<ButtonGroup>
						<Button title="Schließen" icon={<Icon>close</Icon>} secondary onClick={onCloseButtonClicked} />
					</ButtonGroup>
				}
			>
				{props.children}
			</StyledCustomActionContentBox>
		);
	};

const StyledCustomActionContentBox = styled(DefaultWidgetMap.ActionContentbox)`
	& > *[data-role="contentbox-content"] {
		overflow: unset;
		height: 100%;
	}

	& > *[data-role="contentbox-content"] *:not([data-role="repeat-content"] *) {
		height: 100%;
		max-height: 100%;
	}
`;
